<app-home
    [headerMain]="'Developer Admin Portal'"
    [bodyHeader]="'Developer Tools'"
    [bodyContent]="
      'Your One-Stop solution for managing developers portal customers, users and products.'
    "
></app-home>